import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from 'omni-common-ui';
import styles from './style.postcss';

const SubmitConfirmDialog = ({
  isOpen,
  groupName,
  onConfirmClick,
  onCancelClick,
}) => (
  <Dialog
    isOpen={isOpen}
    className={styles.SubmitConfirmDialog_card}
    onRequestClose={() => onCancelClick()}
  >
    <div className={styles.SubmitConfirmDialog}>
      <div className={styles.SubmitConfirmDialog_title}>
        Submit Progress Report
      </div>
      <p className={styles.SubmitConfirmDialog_groupName}>
        {groupName}
      </p>
      <p className={styles.SubmitConfirmDialog_message}>
        Progress Report will be submitted to the DoS for review and then
        published on the parent portal and mini-program.
      </p>
      <Button.Container className={styles.SubmitConfirmDialog_buttons}>
        <Button
          autoWidth
          type={Button.Type.default}
          className={styles.SubmitConfirmDialog_button}
          onClick={() => onCancelClick()}
        >
          Cancel
        </Button>
        <Button
          autoWidth
          type={Button.Type.primary}
          className={styles.SubmitConfirmDialog_button}
          onClick={() => onConfirmClick()}
        >
          Confirm
        </Button>
      </Button.Container>
    </div>
  </Dialog>
);

SubmitConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  groupName: PropTypes.string,
  onConfirmClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

export default SubmitConfirmDialog;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/SubmitConfirmDialog/index.jsx